import { VerificationSession } from '../../../types/verification';

/**
 * Serialize a VerificationSession for the chat mode context.
 * Converts to snake_case plain object for backend consumption.
 */
export function serializeSessionForChat(session: VerificationSession): Record<string, any> {
  return {
    id: session.id,
    title: session.title,
    model_name: session.modelName || '',
    description: session.description || '',
    units: session.units.map((unit) => ({
      unit_number: unit.unitNumber,
      unit_name: unit.unitName,
      items: unit.items.map((item) => ({
        item_name: item.itemName,
        classifications: item.classifications,
        standard_target: item.standardTarget,
        verification_methods_primary: item.verificationMethodsPrimary,
        verification_methods_secondary: item.verificationMethodsSecondary,
      })),
    })),
  };
}

export function buildDrbfmTraceability(
  session: VerificationSession,
): Record<string, any> | null {
  const linkedSessionIds = new Set<string>();
  let linkedCount = 0;
  let totalCount = 0;

  for (const unit of session.units) {
    for (const item of unit.items) {
      totalCount++;
      if (item.sourceDrbfmSessionId) {
        linkedSessionIds.add(item.sourceDrbfmSessionId);
        linkedCount++;
      }
    }
  }

  if (linkedSessionIds.size === 0) return null;

  return {
    linked_drbfm_sessions: Array.from(linkedSessionIds),
    linked_items_count: linkedCount,
    total_items_count: totalCount,
  };
}
